import { UITimerStore } from 'common/stores/UITimerStore';
import { ITimerStrategy } from '.';
import { DisplayConfigType } from '../../config';
import { TIMERS } from 'common/stores/constants/timers.constant';

export class SkanTimer implements ITimerStrategy {
  constructor(
    private adContext: AdContext,
    private formatConfig: DisplayConfigType
  ) {}

  isRunnable(): boolean {
    const hasSkan: boolean =
      this.adContext.skan == true &&
      this.adContext.adUnitType === 'interstitial';

    return hasSkan && (this.formatConfig?.skanTimeout || 0) > 0;
  }

  run(uiTimerStore: UITimerStore): void {
    uiTimerStore.addTimer(
      TIMERS.SKAN_TIMER,
      (this.formatConfig?.skanTimeout || 0) * 1000
    );

    uiTimerStore.get(TIMERS.SKAN_TIMER)!.resume();
  }
}
